export const apiNip = {
	fetchNip: async (nip: string) => {
		const { data } = await apiCommon<INipCheck>(`gus-search-by-nip?nip=${nip}`, { method: 'GET' })
		return NipCheck(data)
	},
}
